var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.83177 7.13345C8.60495 6.91625 8.30209 6.79653 7.98807 6.79994C7.67404 6.80334 7.37386 6.9296 7.1518 7.15166C6.92975 7.37371 6.80346 7.67391 6.80006 7.98794C6.79666 8.30198 6.91639 8.60487 7.13358 8.83168L23.1486 24.8467C23.26 24.9585 23.3924 25.0471 23.5382 25.1076C23.6572 25.1569 23.7831 25.1866 23.9112 25.1958L23.9155 25.2002L23.9993 25.2001C24.2368 25.2001 24.4689 25.1296 24.6664 24.9976C24.8638 24.8656 25.0177 24.6781 25.1086 24.4586C25.1995 24.2392 25.2232 23.9978 25.1769 23.7649C25.1306 23.5319 25.0162 23.3179 24.8483 23.1499L8.8349 7.13645L8.83177 7.13345Z",
    clipRule: "evenodd"
  })));
};
export default SvgLine;